import * as React from "react";
import "./App.css";
import Main from "./containers/Main/Main";
import AuthPage from "./containers/LoginPage/AuthPage";
import AuthCard from "./containers/LoginPage/AuthCard";
import {
  Box,
  IconButton,
  Snackbar,
  Button,
  Alert,
  Typography,
  Stack,
  CardContent,
  AlertTitle,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
// TEST 3
import { useSelector } from "react-redux";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { SnackbarProvider } from "notistack";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { borderRadius } from "@mui/system";
import { RefreshOutlined } from "@mui/icons-material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { useTranslation } from "react-i18next";
import ConsoleHelper from "./utils/ConsoleHelper";
import theme from "./theme/index";
import { red, green, blue } from "@mui/material/colors";

import { QueryClient, QueryClientProvider } from "react-query";
import SubscriptionPageV2 from "containers/Subscription/SubsscriptionPageV2";
import { AppProvider, useApp } from "contexts/AppContext";
import { UserPreferencesProvider } from "contexts/UserPreferencesContext";
import axios from "axios-config"; // our custom axios instance
import Routing from "Routing";
const queryClient = new QueryClient();

const App = (props) => {
  require("dayjs/locale/es");
  const serverDown = useSelector((state) => state.app.serverDown);
  const updateAvailable = useSelector((state) => state.app.updateAvailable);
  const minimumVersionNotMet = useSelector(
    (state) => state.app.minimumVersionNotMet
  );
  // server is down
  const { t, i18n } = useTranslation();
  let dayjs = require("dayjs");
  dayjs.locale(i18n.language);

  const reloadPage = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    //broadcast to all tabs
    const channel = new BroadcastChannel("app-version-channel");
    channel.postMessage({ action: "reload" });

    // window.location.reload(); // refresh the browser
  };
  const { state } = useApp();

  const getMe = async () => {
    const response = await axios.get("/users/me");
    console.log(response);
  };

  // const [isDarkMode, setIsDarkMode] = React.useState(true);

  // const toggleTheme = () => setIsDarkMode((prev) => !prev);

  // Choose theme based on state using the themes from the new folder.
  // const selectedTheme = isDarkMode ? darkTheme : lightTheme;
  const selectedTheme = theme;

  return (
    <QueryClientProvider client={queryClient}>
      {process.env.NODE_ENV === "production" ? null : (
        <>
          <div className="developer-border">
            <div className="top"></div>
            <div className="bottom"></div>
          </div>
        </>
      )}
      <ThemeProvider theme={selectedTheme}>
        <AppProvider>
          <UserPreferencesProvider>
            {/* <CssBaseline /> */}

            <Box className={"sideNavVisible separateOnPageNav"}>
              <SnackbarProvider maxSnack={3}>
                {serverDown ? (
                  <Snackbar
                    open={serverDown}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  >
                    <Stack
                      direction={"row"}
                      justifyContent={"center"}
                      sx={{
                        backgroundColor: red[500],
                        py: "5px",
                        px: "15px",
                        borderRadius: "10px",
                      }}
                      flex={1}
                    >
                      <Typography color={"white.main"} variant="body">
                        {t(
                          "Service temporarily unavailable. Check back shortly."
                        )}{" "}
                      </Typography>
                    </Stack>
                  </Snackbar>
                ) : null}
                <Snackbar open={updateAvailable && !minimumVersionNotMet}>
                  <Alert
                    severity="success"
                    sx={{ width: "100%", border: "1px solid rgba(0,0,0,0.25)" }}
                    icon={<WarningAmberRoundedIcon />}
                    action={
                      <Button
                        onClick={reloadPage}
                        color="success"
                        variant="outlined"
                        size="small"
                        startIcon={<RefreshOutlined />}
                      >
                        {t("app.alert.updateAvailable.action")}
                      </Button>
                    }
                  >
                    {t("app.alert.updateAvailable.message")}
                  </Alert>
                </Snackbar>
                <Routing />
                <Dialog open={minimumVersionNotMet}>
                  <DialogTitle>
                    {t("app.dialogs.minimumVersionNotMet.title")}
                  </DialogTitle>
                  <DialogContent>
                    <Alert severity="warning">
                      <AlertTitle>
                        {t("app.dialogs.minimumVersionNotMet.message")}
                      </AlertTitle>
                      {/* {warningText} */}
                      {t("app.dialogs.minimumVersionNotMet.secondaryMessage")}
                    </Alert>
                    {/* <DialogContentText>{t("app.dialogs.minimumVersionNotMet.message")}</DialogContentText> */}
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={reloadPage}
                      color="success"
                      variant="outlined"
                      size="small"
                      startIcon={<RefreshOutlined />}
                    >
                      {t("app.dialogs.minimumVersionNotMet.action")}
                    </Button>
                  </DialogActions>
                </Dialog>
              </SnackbarProvider>
            </Box>
          </UserPreferencesProvider>
        </AppProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default App;
